import request from '../utils/request'
export function captchaImage(data) {
    return request({
        url: '/captchaImage',
        method: 'get',
        params: data
    })
}

export function register(data) {
    return request({
        url: '/register',
        method: 'post',
        data
    })
}

export function login(data) {
    return request({
        url: '/login',
        method: 'post',
        data
    })
}

export function userProfile(data) {
    return request({
        url: '/system/user/profile',
         method: 'get',
        params: data
    })
}

export function logout(data) {
    return request({
        url: '/logout',
         method: 'get',
        params: data
    })
}
export function updateUserProfile(data) {
    return request({
        url: '/system/user/profile',
         method: 'put',
        data
    })
}

export function pay(data) {
    return request({
        url: '/api/native-pay/create',
        method: 'post',
        data
    })
}
export function payAlipay(data) {
    return request({
        url: '/api/alipay/create-payment',
        method: 'post',
        data
    })
}
 
export function removeUser(id) {
    return request({
        url: `/system/user/${id}`,
         method: 'get',
 
    })
}

export function sendSmsCode(data) {
    return request({
        url: '/sms/code',
        method: 'post',
        data
    })
}
export function smsLogin(data) {
    return request({
        url: '/sms/login',
        method: 'post',
        data
    })
}

export function chatState(data) {
    return request({
        url: `/chat/state/${data.clientId}`,
        method: 'post',
    })
}
export function orderList(data) {
    return request({
        url: '/oa/order/list',
        method: 'get',
        params: data
    })
}

export function securityCode(data) {
    return request({
        url: '/sms/security/code',
        method: 'post',
        data
    })
}

export function checkCode(data) {
    return request({
        url: '/system/user/profile/check/smsCode',
        method: 'post',
        data
    })
}

export function sendMessages(data) {
    return request({
        url: '/chat/sendMessages',
        method: 'post',
        data
    })
}


// 邀请链接
export function inviteGenerate(data) {
    return request({
        url: '/invite/generate',
        method: 'get',
        params: data
    })
}
// 上传
export function commonUpload(data) {
    return request({
        url: '/common/upload',
        method: 'post',
        data
    })
}
// 部署
export function customer(data) {
    return request({
        url: '/oa/customer',
        method: 'post',
        data,
                headers: {
            noProcess: true
        },
    })
}

//  修改账号信息所有账户的验证码 获取 接口 统一   http://localhost:8090/sms/security/code
// 修改账号信息所有账户的验证码 确认 接口 统一 http://localhost:8090/system/user/profile/check/smsCode


// 保存统一接口   /system/user/profile   （startCode、smsCode、uuid  修改邮箱和密码的时候都传空，修改手机的时候都值